import type UserData from "~~/api/response/data/UserData";

export default class User {
  id: string;

  constructor(data: UserData) {
    this.id = data.id;
  }
}
